{
  "loginForm": {
    "forgotPassword": "Recuperar Contraseña",
    "signIn": "Entrar",
    "register": "Registrarse",
    "dontHaveAccount": "Don’t have an account?",
    "guestCheckout": "Guest Checkout",
    "emailAddress": {
      "label": "RUT",
      "placeholder": "Ingrese su RUT"
    },
    "password": {
      "label": "Password",
      "placeholder": "Ingrese su contraseña"
    },
    "wrongEmailFormat": "Formato inválido."
  },
  "miniLogin": {
    "userGreeting": "Hola, {{name}}",
    "signInRegister": "Iniciar sesión"
  },
  "myAccountV2User": {
    "signOut": "Salir"
  }
}
